export default __webpack_public_path__ + "assets/USSF_contract.e72d1ff1.png";